import { makeMonitorRepository } from "../repositories/repositoryBuilders.js";
import session from "../session.js";

/**
 * This service is responsible for fetching, modifying and deleting
 * known report templates of a given owner.
 *
 * @param {Repository} repository - To communicate with the server.
 * @param {Country|Agency|CompanyType} owner - The aggregate which
 *   owns the report templates.
 * @param {string} ownerType - The type of owner (one of "Country", "Agency"
 *   or "CompanyType").
 * @param {function} [canDelete] - Function to check if the service can
 *   delete a report template. Called without any parameter. If not
 *   provided, the service considers it can't delete report templates.
 */
export default class ReportTemplateSettingsService {
	constructor({ repository, owner, ownerType, canDelete = () => false }) {
		this._ownerRepository = repository;
		this._owner = owner;
		this._canDelete = canDelete;

		this._commonRepository = makeMonitorRepository({
			route: "/Shared/ReportTemplate/#ownerType/#ownerId",
			defaultFilters: { ownerType, ownerId: owner.getLegacyId() },
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	}

	getDownloadUrlFor(reportTemplate) {
		const ownerId = this._owner.getLegacyId();
		const reportTemplateId = reportTemplate.getId();

		const url = this._ownerRepository.buildUrl({
			filter: { ownerId, reportTemplateId },
		});

		return `/${url}`;
	}

	findAll(callback = () => {}) {
		this._ownerRepository
			.get({ filter: { ownerId: this._owner.getLegacyId() } })
			.then(callback);
	}

	create({ model, successMessage, callback = () => {} }) {
		this._commonRepository
			.save({ model, successMessage })
			.then(() => callback());
	}

	save({ modelData, callback = () => {} }) {
		this._commonRepository
			.update({ model: modelData })
			.then(() => callback());
	}

	canRestore(model) {
		return model.canBeRestoredFor(this._owner);
	}

	canDelete() {
		return this._canDelete();
	}

	delete({ modelId, callback = () => {} }) {
		this._commonRepository
			.remove({ filter: { reportTemplateId: modelId } })
			.then(() => callback());
	}
}
